export const toUpperFirstLetter = (string: string): string => {
  const suggestions = string
    .split('.')
    .map((sug) => sug[0]?.toUpperCase() + sug.slice(1))
    .join('. ');
  return suggestions;
};
